<template>
  <b-collapse :id="`collapse-${id}`" class="mt-2">

    <ul class="text-right">

      <li class="dashboard-small" v-for="child in children">

        <div class="" v-if="child.children.length">
          <div class=""
               v-if="checkAccess(child)">

            <a href="javascript:;" @click="customAction" :style="`margin-right:${step + 15  }px`"
               v-b-toggle="`collapse-${child.id}`">
              {{ child.name }}
              <b-icon icon="arrow-down-circle" class="mx-2 d-inline"></b-icon>
            </a>

            <sub-item :step="step+5" :id="child.id" :children="child.children"/>
          </div>
        </div>

        <div v-else>
          <router-link class="mr-3 menu-item" v-if="checkAccess(child)" :to="routeManager(child)">
            {{ child.name }}
            <b-icon icon="lock" class="mx-2 " v-if="!checkModuleActive(child)"/>
          </router-link>
        </div>


      </li>

    </ul>


  </b-collapse>
</template>

<script>
import {checkServiceIsExpire} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/SiteServiceManager";

export default {
  name: "subItem",
  props: ['children', 'id', 'step', 'action'],
  methods: {
    customAction() {
      if (this.action !== undefined) {
        this.action()
      }
    },
    checkAccess(item) {
      let userProfile = this.$store.getters['User/getProfile'];
      let access = userProfile.meta?.find(item => item.name == 'user_access');
      let generalRoutes = ['Home', 'Dashboard', 'Profile', 'Address', 'UserOrders', 'LoansUser', 'UserChats', 'UserSubscription']
      if (access != undefined) {
        let values = JSON.parse(access.value).map(item => item.route)

        if (generalRoutes.indexOf(item.route.name) > -1) {
          return true
        }

        if (values.indexOf('*') > -1) {
          return true
        }
        return values.indexOf(item.route.name) > -1
      }

      return true
    },
    checkModuleActive(item) {
      if (process.env.NODE_ENV == 'development') {
        return true
      }
      if (item['module'] !== undefined) {
        return checkServiceIsExpire(item['module'])
      }
      return true
    },
    routeManager(item) {
      if (this.checkModuleActive(item)) {
        return item.route
      }
      return {name: "ModulesList"}
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

ul li {
  list-style: none;
}


ul li a {
  color: #ffffff;
  text-decoration: none;
  display: block;
  padding: 15px 0 15px 10px;
  font-size: 16px;
  outline: none;
}


@media only screen and (max-width: 991px) {
  ul li a {
    color: #fff;
  }
}


</style>